import { useQuery } from '@tanstack/react-query';
import { contabilidadService } from '../services/contabilidadService';
import { toApiDateParams } from '../utils/dateRange';
import type { KpisData } from '../types';
import type { DateRange } from './useDateRangeFilter';

export const KPIS_QUERY_KEY = ['contabilidad', 'kpis'] as const;

export function useKpis(range: DateRange | null = null) {
  const params = toApiDateParams(range);

  const { data, isLoading, error } = useQuery<KpisData>({
    queryKey: [...KPIS_QUERY_KEY, params.fecha_inicio ?? null, params.fecha_fin ?? null],
    queryFn: () => contabilidadService.getKpis(params),
    staleTime: 1000 * 60 * 5,
  });

  return { kpis: data, isLoading, error };
}
